export const SET_PIN_BEGIN = "SET_PIN_BEGIN";
export const SET_PIN_SUCCESS = "SET_PIN_SUCCESS";
export const SET_PIN_FAILURE = "SET_PIN_FAILURE";

export const fetchPINBegin = () => ({
    type: SET_PIN_BEGIN
});

export const fetchPINSuccess = pin => ({
    type: SET_PIN_SUCCESS,
    payload: {
        pin: pin
    }
});

export const fetchNotificationCounterFailure = error => ({
    type: SET_PIN_FAILURE,
    payload: {error}
});
